const pageNameKey = "languageSelectorWithSearch";

export const languageSelectorWithSearchEn = {
  [pageNameKey]: {
    languageLabel: "Language",
    searchPlaceholder: "Search Language",
    noResults: "No results found",
    languages: {
      englishLabel: "English",
      germanLabel: "German",
      chineseSimplifiedLabel: "Chinese",
      italianLabel: "Italian",
      spanishLabel: "Spanish",
      portugueseBrazilianLabel: "Portuguese",
      dutchLabel: "Dutch",
      turkishLabel: "Turkish",
    },
  },
};

export const languageSelectorWithSearchPtBr = {
  [pageNameKey]: {
    languageLabel: "Idioma",
    searchPlaceholder: "Idioma de pesquisa",
    noResults: "Nenhum resultado encontrado",
    languages: {
      englishLabel: "Inglês",
      germanLabel: "Alemão",
      chineseSimplifiedLabel: "Chinês",
      italianLabel: "Italiano",
      spanishLabel: "Espanhol",
      portugueseBrazilianLabel: "Português",
      dutchLabel: "Holandês",
      turkishLabel: "Turco",
    },
  },
};

export const languageSelectorWithSearchDe = {
  [pageNameKey]: {
    languageLabel: "Sprache",
    searchPlaceholder: "Sprache suchen",
    noResults: "Keine Ergebnisse gefunden",
    languages: {
      englishLabel: "Englisch",
      germanLabel: "Deutsch",
      chineseSimplifiedLabel: "Chinesisch",
      italianLabel: "Italienisch",
      spanishLabel: "Spanisch",
      portugueseBrazilianLabel: "Portugiesisch",
      dutchLabel: "Niederländisch",
      turkishLabel: "Türkisch",
    },
  },
};

export const languageSelectorWithSearchZhHans = {
  [pageNameKey]: {
    languageLabel: "语言",
    searchPlaceholder: "搜索语言",
    noResults: "未找到结果",
    languages: {
      englishLabel: "英语",
      germanLabel: "德语",
      chineseSimplifiedLabel: "中文",
      italianLabel: "意大利语",
      spanishLabel: "西班牙语",
      portugueseBrazilianLabel: "葡萄牙语",
      dutchLabel: "荷兰语",
      turkishLabel: "土耳其语",
    },
  },
};

export const languageSelectorWithSearchIt = {
  [pageNameKey]: {
    languageLabel: "Lingua",
    searchPlaceholder: "Cerca lingua",
    noResults: "Nessun risultato trovato",
    languages: {
      englishLabel: "Inglese",
      germanLabel: "Tedesco",
      chineseSimplifiedLabel: "Cinese",
      italianLabel: "Italiano",
      spanishLabel: "Spagnolo",
      portugueseBrazilianLabel: "Portoghese brasiliano",
      dutchLabel: "Olandese",
      turkishLabel: "Turco",
    },
  },
};

export const languageSelectorWithSearchEs = {
  [pageNameKey]: {
    languageLabel: "Idioma",
    searchPlaceholder: "Buscar idioma",
    noResults: "No se encontraron resultados",
    languages: {
      englishLabel: "Inglés",
      germanLabel: "Alemán",
      chineseSimplifiedLabel: "Chino",
      italianLabel: "Italiano",
      spanishLabel: "Español",
      portugueseBrazilianLabel: "Portugués",
      dutchLabel: "Neerlandés",
      turkishLabel: "Turco",
    },
  },
};

export const languageSelectorWithSearchNl = {
  [pageNameKey]: {
    languageLabel: "Taal",
    languages: {
      englishLabel: "Engels",
      germanLabel: "Duits",
      chineseSimplifiedLabel: "Chinees",
      italianLabel: "Italiaans",
      spanishLabel: "Spaans",
      portugueseBrazilianLabel: "Portugees",
      dutchLabel: "Nederlands",
      turkishLabel: "Turks",
    },
    noResults: "Geen resultaten gevonden",
    searchPlaceholder: "Taal zoeken",
  },
};

export const languageSelectorWithSearchTr = {
  [pageNameKey]: {
    languageLabel: "Dil",
    searchPlaceholder: "Dil ara",
    noResults: "Sonuç bulunamadı",
    languages: {
      englishLabel: "İngilizce",
      germanLabel: "Almanca",
      chineseSimplifiedLabel: "Çince",
      italianLabel: "İtalyanca",
      spanishLabel: "İspanyolca",
      portugueseBrazilianLabel: "Portekizce",
      dutchLabel: "Felemenkçe",
      turkishLabel: "Türkçe",
    },
  },
};
